import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted, watch, nextTick } from 'vue';
import { useDeviceCommon } from '@blade-sxp/monitoring-center/pages/preview/utils/useDevice';
import colors from '@/styles/color.scss';
export default /*#__PURE__*/ _defineComponent({
    __name: 'device-tree',
    setup(__props) {
        const { getDeviceTree, filterNode, isSelectedItem, isDragAble, handleNodeClick, dragstart, dragend } = useDeviceCommon();
        const filterText = ref('');
        const treeData = ref([]);
        const elTreeNode = ref(null);
        onMounted(async () => {
            treeData.value = await getDeviceTree();
        });
        watch(filterText, (val) => {
            nextTick(() => elTreeNode.value.filter(val)); // 放nexttick里，避免不必要的重复渲染
        });
        return { __sfc: true, getDeviceTree, filterNode, isSelectedItem, isDragAble, handleNodeClick, dragstart, dragend, filterText, treeData, elTreeNode, colors };
    }
});
